import React from 'react'
import styled from 'styled-components'
import FormInput from './FormInput'
import PrimaryBtn from './PrimaryBtn'
import { PayPalButton } from "react-paypal-button-v2";
import { toast } from 'react-toastify';


const OrderProcessing = ({
    handleFormSubmit,
    shippingDetails,
    handleLandMarkChange,
    handleAddChange,
    handlePinCodeChange,
    processToPayment,
    paymentButtonLabel,
    handlePaymentButton,
    amount
}) => {
  return (
    <FormWrapper>
        {
            !processToPayment?
            <StyledForm onSubmit={handleFormSubmit}>
                <fieldset className="shipping_details">
                    <legend className="shipping_form_title">
                        Shipping Details
                    </legend>
                    <label htmlFor="address" className="shipping_label">Shipping Address</label>
                    <FormInput value={shippingDetails?.address} id="address" type="text" handleOnChange={handleAddChange} />
                    <label htmlFor="landmark" className="shipping_label">Landmark</label>
                    <FormInput id="landmark"  value={shippingDetails?.landmark} type="text"  handleOnChange={handleLandMarkChange} />
                    <label htmlFor="pincode" className="shipping_label">Zip Code</label>
                    <FormInput id="pincode" type="text" value={shippingDetails?.zipcode} handleOnChange={handlePinCodeChange}  />
                    <PrimaryBtn type="submit" label="Checkout" />
                </fieldset>
        </StyledForm>
        :
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%'}}>
             <PayPalButton
               options={{
                clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID,
                currency: 'EUR'
              }}
        amount={amount}
        // shippingPreference="NO_SHIPPING" // default is "GET_FROM_FILE"
        onSuccess={(details, data) => {
          toast.success("Transaction completed by " + details.payer.name.given_name);
        }}
      
      />
            {/* <PrimaryBtn handleBtn={handlePaymentButton}  label={`Pay ${paymentButtonLabel}`} />  */}
        </div>
            
        }
    </FormWrapper>
  )
}

export default OrderProcessing

const FormWrapper = styled.div`
    display: flex;
    background: none;
`
const StyledForm = styled.form`
    width: 100%;
    background: none;
`